<template>
  <ProductDescriptionDrawerBase
    :title="$t('product.description.framingService')"
  >
    <template #content>
      <div class="flex flex-col-reverse lg:flex-row justify-between gap-2 py-2">
        <div class="flex flex-col gap-2">
          <FramingUSPs icon-colour="text-platform-neutral" />
          <BaseNuxtLinkButton
            class="mt-4"
            link-path="https://www.matchwornshirt.com/framing-service"
            color-scheme="text-only"
          >
            {{ $t("common.findOutMore") }}
          </BaseNuxtLinkButton>
          <FramingBrandAttribution />
        </div>

        <NuxtImg
          :src="framingImage"
          class="object-contain max-w-[60%] flex self-center -mt-4 lg:-mt-10"
          alt="framed shirts"
          provider="imgix"
          preset="simpleFormatAndCompression"
          loading="lazy"
        />
      </div>
    </template>
  </ProductDescriptionDrawerBase>
</template>
